module.exports = __webpack_public_path__ + "img/2_Wawa_Screen_1.f4726fe8.jpg";